export interface DscNotesListKeyArguments {
  approvalId: string;
  /** caps2-parity phase filter; always "all" today (mirrors caps2 isShowAllPreAppHist=true). */
  phase: string;
}

/**
 * Hierarchical query-key factory for the DSC Pre-approval Change History feature
 * (OR-21039). The shape mirrors the sibling stipulation/docs key factories so
 * cache invalidation stays predictable: invalidating `all` flushes every
 * change-history query, `lists()` only flushes list queries, and
 * `list({ approvalId, phase })` flushes a single deal+phase combination. Never
 * write a literal key array outside this module — the factory IS the schema.
 *
 * Keyed on approvalId + phase: the BFF endpoint is
 * `/api/v1/workbench/{approvalId}/dsc-notes?phase={phase}`. caps2 always passes
 * `phase=all`, but the param is part of the key so a future phase filter reuses
 * this factory without a cache collision.
 */
export const dscNotesKeys = {
  all: ["dscNotes"] as const,
  lists: () => [...dscNotesKeys.all, "list"] as const,
  list: (arguments_: DscNotesListKeyArguments) => [...dscNotesKeys.lists(), arguments_] as const,
};
